<div class="timer-container" [class.expired]="isExpired()" [class.urgent]="isUrgent()">
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" class="timer-icon">
    <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/>
    <path d="M8 4V8L11 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
  </svg>
  <span class="timer-text">{{ timeRemaining() }}</span>
</div>